import { render, staticRenderFns } from "./LanguageSettings.vue?vue&type=template&id=436bf236&scoped=true&"
import script from "./LanguageSettings.vue?vue&type=script&lang=ts&"
export * from "./LanguageSettings.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSettings.vue?vue&type=style&index=0&id=436bf236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436bf236",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCard,VRadio,VRadioGroup})
